import api from "../../api/api";
import { responseError } from "../../api/apiError";
import { ErrorMessages } from "../../constants/messages";

/**
 * The BuilderMetrix user record for the signed-in caller. SSO proves who the user is; this says
 * what they may do, so a rights change in BuilderMetrix needs no add-in release.
 */
export type LoggedInUser = {
  isTemplateEditor: boolean;
};

export async function fetchLoggedInUser(authToken: string, identityProvider: string): Promise<LoggedInUser> {
  const response = await api.fetch("user/me", authToken, identityProvider);
  if (!response.ok) {
    throw await responseError(response, ErrorMessages.LoadUserFailed);
  }

  const data = await response.json();
  return { isTemplateEditor: data?.isTemplateEditor === true };
}
